import { useEffect, useState } from 'react';
import { useLazyGetActiveTripsListQuery } from '../../../features/Dispatch/TripDispatchSlice';
import '../../../style.css';

const ActiveTripList = (props) => {
    const [getActiveTripsList, activeTripsList] = useLazyGetActiveTripsListQuery();
    const [trips, setTrips] = useState([]);

    useEffect(async () => {
        if (props.divisionId) {
            await getActiveTripsList(props.divisionId)
        } else {
            setTrips([])
        }
    }, [props.divisionId])

    useEffect(() => {
        if (activeTripsList?.data?.data) {
            if (props.isOpen === 1) {
                setTrips(activeTripsList?.data?.data)
            }
            else {
                setTrips(activeTripsList?.data?.data.filter(trip => trip.tripStatusID === props.isOpen))
            }
        }
        else {
            setTrips([])
        }
    }, [activeTripsList, props.isOpen])

    const statusMap = {
        'O': 'Open',
        'L': 'Loading',
        'OUT': 'Outbound',
        'IN': 'Inbound',
        'C': 'Completed',
    }

    return (
        <div className="h-100 pb-2">
            <fieldset className="overflow-auto" style={{ minHeight: '580px', height: "100%", overflowY: 'auto', borderTop:"none", borderRadius:"0px 0px 5px 5px" }}>
                {trips.length === 0 ? <div className='activeTripListContainer' > <h5 className='text-danger'>
                    No Active Trips
                </h5> </div> : <div className="mainContainer" >
                    {trips?.map((trip, index) => (
                        <div className='d-flex flex-column'>
                            <div
                                key={index}
                                className={`tripCard my-2 shadow bg-body rounded flex-wrap ${props.selectedTrip?.tripID === trip.tripID ? 'bg-primary' : ''}`}
                                onClick={async () => {
                                    props.setSelectedTrip(trip)
                                    await props.getSelectedTripDetails({ tripId: trip?.tripID, divisionId: props.divisionId })
                                    props.setIsEditActiveTrip(true)
                                    const orders = props.getTripOrdersClassification({ tripStatus: statusMap[trip?.tripStatusCode], tripId: trip?.tripID, divisionId: props.divisionId })
                                }}
                            >
                                <div className={`${props.selectedTrip?.tripID === trip.tripID ? 'bg-primary' : ''} `}>
                                    <div className="activeTripBox">
                                        <div className={`tripBox ${props.selectedTrip?.tripID === trip.tripID ? 'selected' : ''}`}>
                                            <label>Trip Number</label>
                                            <h6><span>{trip.tripNo}</span></h6>
                                        </div>
                                        <div className="tripBoxStatus">
                                            <label>Status</label>
                                            <span>{trip.tripStatusCode}</span>
                                        </div>
                                    </div>
                                    <div className="activeTripBox">
                                        <div className="description">
                                            <label>Date | Destination</label>
                                            <h6><span>{trip.dateDescription}</span></h6>
                                        </div>
                                        <div className="descriptionAssigned">
                                            <label>Assigned Driver</label>
                                            <span>{trip.assignedDriver}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>}
            </fieldset >
        </div >
    );
}

export default ActiveTripList
